import React from "react";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import Link from "../../../Link";

const SupportMenu = ({ data, isActive }) => {
  const { t } = useTranslation();
  return (
    <div
      id="sub-menu__support"
      className={cx(
        "pl-xl-4 container sub-menu sub-menu__support row",
        { active: isActive },
        { inactive: !isActive }
      )}
    >
      <div className="col mx-1 mx-xl-3 mt-5">
        <Link className="d-block" to={`/support/`}>
          <h5>{t("menu.support.content.title")}</h5>
          <span>{t("menu.support.content.description")}</span>

          <p className="content-link mt-3">{t("common.visit")} &#8594;</p>
        </Link>
      </div>

      <div className="col-8 mx-1 mx-xl-3 mt-5">
        <div className="row">
          <div className="col-5 col-xl-4">
            <span className="title">
              {t("menu.support.supportCenter.title")}
            </span>
            <div className="mt-3">
              <Link to={`/support/general-faqs/`}>
                <h6 className="mb-4 pb-2">
                  {t("menu.support.supportCenter.generalFaqs")}
                </h6>
              </Link>
              <Link to={`/support/getting-started/`}>
                <h6 className="mb-4 pb-2">
                  {t("menu.support.supportCenter.gettingStarted")}
                </h6>
              </Link>
              <Link to={`/support/account-management/`}>
                <h6 className="mb-4 pb-2">
                  {t("menu.support.supportCenter.accountManagement")}
                </h6>
              </Link>
            </div>
          </div>
          <div className="col-5 col-xl-4">
            <span className="title">&nbsp;</span>
            <div className="mt-3">
              <Link to={`/support/trading/`}>
                <h6 className="mb-4 pb-2">
                  {t("menu.support.supportCenter.trading")}
                </h6>
              </Link>
              <Link to={`/support/fiat-transfers/`}>
                <h6 className="mb-4 pb-2">
                  {t("menu.support.supportCenter.fiatTransfer")}
                </h6>
              </Link>
              <Link to={`/support/digital-assets-transfers/`}>
                <h6 className="mb-4 pb-2">
                  {t("menu.support.supportCenter.digitalAssetTransfer")}
                </h6>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportMenu;
